import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

interface TopBarProps {
  title: string;
  breadcrumb?: string[];
}

export default function TopBar({ title, breadcrumb }: TopBarProps) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [showNotif, setShowNotif] = useState(false);
  const [showUser, setShowUser] = useState(false);
  const [search, setSearch] = useState('');
  const [results, setResults] = useState<any[]>([]);

  useEffect(() => {
    if (!search) {
      setResults([]);
      return;
    }

    const delay = setTimeout(() => {
      fetch(`https://guardiancloudcare.com/backend/api/search_children.php?query=${search}`)
        .then(res => res.json())
        .then(data => setResults(data))
        .catch(err => console.error(err));
    }, 300); // debounce

    return () => clearTimeout(delay);
  }, [search]);

  return (
    <header className="h-16 bg-white border-b border-gray-100 flex items-center px-6 gap-4 relative z-20">
      {/* Breadcrumb */}
      <div className="flex-1">
        {breadcrumb && breadcrumb.length > 0 && (
          <div className="flex items-center gap-1 text-xs text-gray-400 mb-0.5">
            {breadcrumb.map((crumb, i) => (
              <span key={i} className="flex items-center gap-1">
                {i > 0 && <i className="ri-arrow-right-s-line" />}
                <span>{crumb}</span>
              </span>
            ))}
          </div>
        )}
        <h1 className="text-base font-semibold text-gray-800">{title}</h1>
      </div>

      {/* Search */}
      <div className="hidden md:flex items-center gap-2 bg-gray-50 rounded-full px-4 py-2 w-64 border border-gray-200">
        <i className="ri-search-line text-gray-400 text-sm" />
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search cases, children..."
          className="bg-transparent text-sm text-gray-600 outline-none w-full placeholder-gray-400"
        />
        <span className="text-xs text-gray-300 hidden lg:block"></span>
      </div>

      {results.length > 0 && (
        <div className="absolute top-16 left-0 w-64 bg-white border border-gray-200 rounded-xl shadow-lg z-50">
          {results.map((r, i) => (
            <div
              key={i}
              onClick={() => navigate(`/child-profiles/${r.case_number}`)}
              className="px-4 py-2 text-sm hover:bg-gray-100 cursor-pointer"
            >
              <p className="font-medium text-gray-800">{r.full_name}</p>
              <p className="text-xs text-gray-400">{r.case_number}</p>
            </div>
          ))}
        </div>
      )}

      {user?.role === 'social_worker' && (

        <button
          onClick={() => navigate('/case-intake')}
          className="hidden md:flex items-center gap-2 bg-teal-500 hover:bg-teal-600 text-white text-sm px-4 py-2 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-add-line" />

          <span>New Case</span>
        </button>

      )}



      {/* <div className="relative">
        <button
          onClick={() => { setShowNotif(!showNotif); setShowUser(false); }}
          className="relative w-9 h-9 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
        >
          <i className="ri-notification-3-line text-gray-600 text-lg" />
          {unreadCount > 0 && (
            <span className="absolute top-1 right-1 w-4 h-4 bg-red-500 text-white text-xs rounded-full flex items-center justify-center font-bold">
              {unreadCount}
            </span>
          )}
        </button>

        {showNotif && (
          <div className="absolute right-0 top-12 w-80 bg-white rounded-xl border border-gray-100 overflow-hidden z-50">
            <div className="px-4 py-3 border-b border-gray-100 flex items-center justify-between">
              <span className="font-semibold text-sm text-gray-800">Notifications</span>
              <button className="text-xs text-teal-500 cursor-pointer whitespace-nowrap">Mark all read</button>
            </div>
            <div className="max-h-72 overflow-y-auto">
              {notifications.map((n) => (
                <div key={n.id} className={`px-4 py-3 border-b border-gray-50 hover:bg-gray-50 cursor-pointer ${!n.read ? 'bg-teal-50/30' : ''}`}>
                  <div className="flex items-start gap-3">
                    <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5 ${notifColors[n.type]}`}>
                      <i className={`${notifIcons[n.type]} text-sm`} />
                    </div>
                    <div className="flex-1">
                      <p className="text-xs text-gray-700 leading-relaxed">{n.text}</p>
                      <p className="text-xs text-gray-400 mt-1">{n.time}</p>
                    </div>
                    {!n.read && <span className="w-2 h-2 rounded-full bg-teal-400 flex-shrink-0 mt-1" />}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div> 

      <div className="relative">
        <button
          onClick={() => { setShowUser(!showUser); setShowNotif(false); }}
          className="flex items-center gap-2 cursor-pointer"
        >
          <div className="w-8 h-8 rounded-full bg-teal-500 flex items-center justify-center text-white text-xs font-bold">
            {user?.avatar}
          </div>
          <i className="ri-arrow-down-s-line text-gray-400 text-sm hidden md:block" />
        </button>

        {showUser && (
          <div className="absolute right-0 top-12 w-48 bg-white rounded-xl border border-gray-100 overflow-hidden z-50">
            <div className="px-4 py-3 border-b border-gray-100">
              <p className="text-sm font-semibold text-gray-800">{user?.name}</p>
              <p className="text-xs text-gray-400">{user?.email}</p>
            </div>
            <button className="w-full px-4 py-2.5 text-left text-sm text-gray-600 hover:bg-gray-50 flex items-center gap-2 cursor-pointer">
              <i className="ri-user-line text-gray-400" />
              My Profile
            </button>
            <button className="w-full px-4 py-2.5 text-left text-sm text-gray-600 hover:bg-gray-50 flex items-center gap-2 cursor-pointer">
              <i className="ri-settings-3-line text-gray-400" />
              Settings
            </button>
            <button className="w-full px-4 py-2.5 text-left text-sm text-gray-600 hover:bg-gray-50 flex items-center gap-2 cursor-pointer">
              <i className="ri-shield-user-line text-gray-400" />
              Audit Trail
            </button>
          </div>
        )}
      </div>
      {(showNotif || showUser) && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => { setShowNotif(false); setShowUser(false); }}
        />
      )} */}
    </header>
  );
}
